import { FieldErrors } from 'react-hook-form';
import { CaseLinkType } from '@/api/apis/case';

export const validateCurrentLink = (
  editingIndex: number | null,
  formErrors: FieldErrors,
  currentLink: CaseLinkType | undefined,
  trigger: (name: string) => void,
): boolean => {
  if (editingIndex === null) return true;

  const linkErrors = (formErrors?.links ?? []) as unknown[];
  const hasErrors = !!linkErrors[editingIndex];

  if (hasErrors || !currentLink?.url) {
    trigger(`links.${editingIndex}`);
    return false;
  }

  return true;
};

export const adjustEditingIndexAfterDelete = (
  deletedIndex: number,
  currentIndex: number | null,
  totalLinksAfterDelete: number,
): number | null => {
  if (currentIndex === null) return null;

  if (deletedIndex === currentIndex) {
    const nextIndex = deletedIndex < totalLinksAfterDelete ? deletedIndex : null;
    return nextIndex;
  }

  if (deletedIndex < currentIndex) {
    return currentIndex - 1;
  }

  return currentIndex;
};
